/* src/app/dialogs/article-sort-wizard/article-sort-wizard.component.css */
a {
  cursor: pointer;
}
a:link,
a:visited {
  color: #000;
  text-decoration: underline;
}
a:active,
a:hover {
  color: #000;
  text-decoration: none;
}
.msgbox {
  cursor: pointer;
  border-radius: 10px;
  text-align: center;
}
/*# sourceMappingURL=article-sort-wizard.component-QVXFK7IH.css.map */
